/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react'
import imageCompression from 'browser-image-compression'
import styles from './FileManagerComponent.scss'
import { connect } from 'react-redux'
import { getUser, getLanguageKeys, getFileManager } from '@/store/getters'
import {
  setLockBackground,
  showFileManager,
  showAlert,
  closeAlert,
  toggleUploaderActive
} from '@/store/actions'
import { SpinnerLoader } from '@/components/commons/LoaderComponent'
import SearchBox from '@/components/SearchBox'
import { UploadResource } from '@/resources'

class FileManager extends Component {
  state = {
    loader: false,
    imageSelect: {
      id: '',
      src: ''
    },
    files: [],
    hover: false,
    filterImage: ''
  }

  componentDidMount() {
    const { id_usuario } = this.props.user.user
    UploadResource.getUploads(id_usuario)
      .then(({ data }) => {
        if (!data.success) return this.onError(data.msg)
        this.setState({ files: data.images.files })
      })
      .catch(data => console.error(data))
  }

  /**
   * Close the file manager
   */
  closeFileManager = () => {
    this.props.showFileManager({ isOpened: false })
    this.props.setLockBackground({ isVisible: false })
  }

  /**
   * Open the file manager
   */
  /**openFileManager = () => {
    this.props.showFileManager( { isOpened: true } )
    this.props.setLockBackground( { isVisible: true } )
  }*/

  /**
   * Verify size of file
   */
  sizeFile = () => {
    const { showAlert, locales } = this.props
    showAlert({
      title: locales['image-size-title'],
      message: locales['image-send-message'],
      imageUpload: true,
      callback: () => this.returnImageUpload(),
      hasCancel: true
    })
  }

  /**
   * 
   * @param {File} file 
   */
  compressImageWithDimensionBig = async (file) => {
    const options = {
      maxSizeMB: 4,
      maxWidthOrHeight: 1999,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(file, options)

      var newFile = new File([compressedFile], file.name, { type: file.type, lastModified: Date.now() })
      this.sendImage(newFile)

    } catch (error) {
      console.log(error)
    }
  }

  /**
   * Verify format of file
   */
  formatFile = () => {
    const { showAlert, locales } = this.props
    showAlert({
      title: locales['image-format-title'],
      message: locales['image-send-message'],
      imageUpload: true,
      callback: () => this.returnImageUpload(),
      hasCancel: true
    })
  }

  /**
   * Verify width of file
   *  @param {Int} width
   */
  widthFile = width => {
    const { showAlert, locales } = this.props
    showAlert({
      title: locales['image-width-title'],
      message: locales['image-send-message'],
      imageUpload: true,
      callback: () => this.returnImageUpload(),
      hasCancel: true
    })
  }

  /**
   * When image is selected
   * @param {FileList} files
   */
  onImageUpload = files => {
    if (!files.length) return
    const file = files[0]
    const formats = /png|jpeg|jpg|svg|webp|gif/gi

    if (file.size > 4000000) return this.sizeFile()
    if (!formats.exec(file.type)) return this.formatFile()

    const _URL_ = window.URL || window.webkitURL
    const url = _URL_.createObjectURL(file)
    const image = new Image()
    image.onload = () => {

      if (image.width > 5000) return this.widthFile(image.width)

      this.startSendProccess()

      if (image.naturalWidth > 2000) {
        this.compressImageWithDimensionBig(file)
      } else {
        this.sendImage(file)
      }
    }
    image.src = url
  }

  /**
   * SEND IMAGE AGAIN
   */
  returnImageUpload = () => {
    this.props.closeAlert()
    let upload = document.getElementById('imageUpload')
    upload.click()
  }

  /**
   * SEND THE IMAGE TO SERVER
   */
  sendImage = file => {
    const { files } = this.state
    const { id_usuario } = this.props.user.user

    const formData = new FormData()
    formData.append('image', file)

    UploadResource.saveUpload(id_usuario, formData).then(({ data }) => {
      if (!data.success) return this.onError(data.msg)
      this.startSendProccess()
      this.setState({ files: [data.data, ...files] })
    })
  }

  /**
   * WHEN THE FAIL IN SAVE, DELETE OR GET A IMAGE
   * @param {String} msg
   */
  onError = msg => {
    const { showAlert, closeAlert } = this.props
    showAlert({
      title: 'Error',
      message: msg,
      icon: 'sentiment_very_dissatisfied',
      type: 'error',
      callback: () => closeAlert()
    })

    return
  }

  /**
   * SHOW LOADER AND TRY TO SEND
   */
  startSendProccess = () => {
    this.setState({ loader: !this.state.loader })
  }

  /**
   * FILTER IMAGE
   * @param {String} filter
   */
  onFilterImage = filter => {
    this.setState({ filterImage: filter })
  }

  /**
   * SELECT A IMAGE
   */
  onSelectImage = target => {
    this.setState({
      imageSelect: {
        id: target.id,
        src: `https://www.omb11.com${target.path}/${target.file}`
      }
    })
  }

  /**
   * CONFIRM A IMAGE
   */
  onConfirmImage = () => {
    const { callback } = this.props.fileManager
    const { src } = this.state.imageSelect
    this.closeFileManager()
    callback(src)
  }

  /**
   * DELETE A IMAGE
   */
  onDeleteImage = () => {
    const { id_usuario } = this.props.user.user
    const {
      imageSelect: { id },
      files
    } = this.state

    UploadResource.deleteUpload(id_usuario, id)
      .then(({ data }) => {
        if (!data.success) this.onError(data.msg)
        let newFiles = files.filter(file => file.id !== id)
        this.setState({ files: newFiles })
      })
      .catch(err => console.log(err))
  }

  render() {
    const { locales, showAlert, closeAlert } = this.props
    const { imageSelect, filterImage, loader } = this.state
    let { files } = this.state

    if (filterImage !== '') {
      files = files.filter(element => {
        return (
          element.name.toLowerCase().indexOf(filterImage.toLowerCase()) !== -1
        )
      })
    }

    return (
      <div className={styles['upload-modal']}>
        <div className='ba-card ba-w-100'>
          <div className='ba-top ba-flex ba-mg-t-1'>
            <span className={`ba-title ${styles['upload-modal__title']}`}>{locales['general-recent-uploads']}</span>
            <div className={`ba-box-items ba-flex ba-gp-1 ${styles['upload-modal__input-wrapper']}`}>
              <SearchBox
                handleChange={e => this.onFilterImage(e)}
                label={locales['dashboard-search']}
              />
              <div>
                <label htmlFor="imageUpload" className={styles['upload-modal__input-wrapper__input']}>
                  <div>
                    {!loader ? (<span>{locales['general-new-image-upload']}</span>) : (
                      <div> <SpinnerLoader /> </div>
                    )}
                  </div>
                  <input
                    id="imageUpload"
                    type="file"
                    //accept="image/*"
                    onChange={e => {
                      this.onImageUpload(e.target.files)
                    }}
                  />
                </label>
                <span className={styles['upload-info']}>
                  {locales['image-format-info']}
                </span>
              </div>
            </div>
          </div>
          <div className='ba-content ba-w-100 ba-h-100'>
            <div className={`ba-w-100 ba-flex ba-ai-center ba-jc-sb ba-mg-y-1 ${styles['upload-modal__images-header']}`}>
              <span>{locales['general-name']}</span>
              <span>{locales['general-action']}</span>
            </div>
            <div className={`${styles['upload-modal__images-wrapper']}`}>
              {files.map((element, index) => (<div key={index} className={`ba-flex ba-ai-center ba-jc-sb ba-pd-x-1 ba-mg-y-1 ${styles['upload-modal__images-wrapper__item']}`} onMouseEnter={() => this.onSelectImage(element)}>
                <div className={'ba-flex ba-ai-center'}>
                  <div className={`ba-mg-r-1 ${styles['upload-modal__image-thumb']}`}>
                    <img
                      src={`https://www.omb11.com${element.path}/${element.file}`}
                      alt={element.name}
                      data-image-id={element.id}
                    />
                  </div>
                  <span className={`${styles['upload-modal__image-text']}`} >{element.name}</span>
                </div>
                <div className={styles['upload-modal__images-wrapper__item__vertical-line']}></div>
                <div className={'ba-flex ba-ai-center ba-jc-fe ba-gp-1 ba-h-100'}>
                  <button class='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={() => this.onConfirmImage()}>
                    <builderall-icon code='ad00' />
                  </button>
                  <button class='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={() => window.open(imageSelect.src)}>
                    <builderall-icon code='search' />
                  </button>
                  <button class='ba-btn ba-btn-trash ba-sm ba-rounded'
                    onClick={() => {
                      this.closeFileManager()
                      showAlert({
                        callback: () => {
                          this.onDeleteImage()
                          closeAlert()
                        },
                        title: locales['image-remove-image'],
                        message: locales['general-delete-message'],
                        icon: 'delete',
                        hasCancel: true,
                        type: 'error'
                      })
                    }
                    }
                  >
                    <builderall-icon code='trash' />
                  </button>
                </div>
              </div>
              ))}
            </div>
          </div>
          <div class='ba-bottom ba-flex ba-w-100 ba-ai-center ba-jc-fe'>
            <button
              type="button"
              className={`${styles['upload-modal__cancel-button']}`}
              onClick={() => this.closeFileManager()}
            >
              {locales['general-cancel']}
            </button>
          </div>
        </div>
        {/* <aside>
          <div className={styles['upload']}>
            {!loader ? (
              <React.Fragment>
                <label htmlFor="imageUpload" className={styles['upload-image']}>
                  <div>
                    <span>UPLOAD</span>
                  </div>
                  <input
                    id="imageUpload"
                    type="file"
                    //accept="image/*"
                    onChange={e => {
                      this.onImageUpload( e.target.files )
                    }}
                  />
                </label>
                <span className={styles['upload-info']}>
                  {locales['image-format-info']}
                </span>
              </React.Fragment>
            ) : (
              <SpinnerLoader />
            )}
          </div>
          <div className={styles['directory']}>
            <div>
              <IconComponent icon="folder" />
              <span>/</span>
            </div>
          </div>
        </aside> */}
        {/* <div className={styles['images']}> */}
        {/* <div className={styles['search-images']}>
            <div className="searchbox-file-manager">
              <IconComponent icon="search" />
              <input
                type="text"
                placeholder={locales['dashboard-search']}
                onChange={e => this.onFilterImage( e.target.value )}
              />
            </div>
          </div> */}
        {/* <div className={styles['user-images']}>
            {files.map( ( element, index ) => (
              <div
                className={styles['image-container']}
                key={index}
                onMouseEnter={() => this.setState( { hover: true } )}
                onMouseLeave={() => this.setState( { hover: false } )}
              >
                {hover && imageSelect.id === element.id && (
                  <div className={styles['image-options']}>
                    <button
                      type="button"
                      onClick={() => this.onConfirmImage()}
                      className={styles['button-confirm']}
                    >
                      <IconComponent icon="confirm" />
                    </button>
                    <button
                      type="button"
                      onClick={() => window.open( imageSelect.src )}
                    >
                      <IconComponent icon="search" />
                    </button>
                    <button
                      type="button"
                      onClick={() =>  {
                        this.closeFileManager()                        
                        showAlert( {     
                          callback: () => {
                            this.onDeleteImage()
                            closeAlert()
                          },
                          title: locales['image-remove-image'],
                          message: locales['general-delete-message'],
                          icon: 'delete',
                          hasCancel: true,
                          type: 'error'
                        } )}    
                      }
                    >
                      <IconComponent icon="delete" />
                    </button>
                  </div>
                )}
                <img
                  src={`https://www.omb11.com${element.path}/${element.file}`}
                  alt={element.name}
                  data-image-id={element.id}
                  onMouseEnter={e => this.onSelectImage( e.target )}
                />
                <span>{element.name}</span>
              </div>
            ) )}
          </div>
          <div className={styles['option-cancel']}>
            <button
              type="button"
              className="basic-button button-cancel m-right-large"
              onClick={() => this.closeFileManager()}
            >
              {locales['general-cancel']}
            </button>
          </div>
        </div> */}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const user = getUser(state)
  const locales = getLanguageKeys(state)
  const fileManager = getFileManager(state)
  return { user, locales, fileManager }
}

export default connect(
  mapStateToProps,
  {
    setLockBackground,
    showFileManager,
    showAlert,
    closeAlert,
    toggleUploaderActive
  }
)(FileManager)



// WEBPACK FOOTER //
// ./src/components/fileManager/FileManagerComponent.js